// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZjEU","top":"styles_top__1Mv0N","left":"styles_left__3VrEq","description":"styles_description__3aaxF"};